<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 356 370"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.26144 260.669C1.26144 260.669 -2.45857 242.003 2.87793 232.129C8.21442 222.254 24.2239 232.892 22.7007 219.231C21.1774 205.569 10.5045 143.33 43.2799 128.151C76.0553 112.973 124.84 131.938 139.326 90.1906C153.813 48.443 152.279 18.0867 201.064 17.3334C249.849 16.5802 340.559 134.219 345.895 170.652C351.232 207.086 298.416 238.939 296.955 257.924C295.494 276.91 327.554 320.938 317.679 336.879C307.804 352.821 305.483 356.608 305.483 356.608L1.26144 260.669Z"
      :fill="color"
    />
    <path
      opacity="0.7"
      d="M1.26144 260.669C1.26144 260.669 -2.45857 242.003 2.87793 232.129C8.21442 222.254 24.2239 232.892 22.7007 219.231C21.1774 205.569 10.5045 143.33 43.2799 128.151C76.0553 112.973 124.84 131.938 139.326 90.1906C153.813 48.443 152.279 18.0867 201.064 17.3334C249.849 16.5802 340.559 134.219 345.895 170.652C351.232 207.086 298.416 238.939 296.955 257.924C295.494 276.91 327.554 320.938 317.679 336.879C307.804 352.821 305.483 356.608 305.483 356.608L1.26144 260.669Z"
      fill="white"
    />
    <path
      d="M299.027 354.823L313.4 359.322"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.9961 268.201L288.634 351.573"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M154.984 365.719L187.345 330.049L85.1429 295.658L56.015 331.328L154.984 365.719Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M151.896 356.236L173.625 332.897L95.8781 305.563L74.1487 330.616L151.896 356.236Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M140.487 197.562C140.487 197.562 124.446 201.793 117.69 208.149C110.934 214.505 107.826 226.247 107.826 226.247C107.826 226.247 98.738 233.944 94.4792 236.256C91.0126 237.997 87.929 240.409 85.4081 243.35C82.8871 246.29 80.9794 249.701 79.7961 253.384C76.3144 263.785 72.0659 287.269 72.0659 287.269L82.884 292.284C82.884 292.284 83.0808 286.093 92.7487 276.693C102.417 267.293 108.396 251.279 109.173 250.897C109.95 250.515 126.954 239.351 126.954 239.351C126.954 239.351 140.104 248.39 154.984 250.897C169.864 253.405 186.298 250.701 186.298 250.701L181.656 264.951C181.656 264.951 171.024 269.563 168.32 275.145C165.615 280.727 152.859 301.9 152.859 301.9L161.947 309.216C169.13 303.893 176.757 299.192 184.744 295.163C198.08 288.425 201.323 283.616 205.23 275.723C208.775 267.864 211.746 259.76 214.12 251.475C214.317 250.123 218.182 246.667 218.762 238.381L219.343 230.127L239.632 212.039C250.768 207.127 260.771 199.987 269.019 191.062C282.355 176.43 284.479 169.311 285.836 156.217C287.194 143.123 292.603 91.3564 292.789 90.5825C292.976 89.8087 294.727 85.9703 297.048 85.5782C299.369 85.1861 312.125 96.3607 313.866 97.5164C315.607 98.672 319.047 99.2498 319.462 95.5869C319.876 91.9239 316.757 82.8851 306.903 73.0724C297.048 63.2598 289.888 61.7224 287.577 64.2194C285.267 66.7164 286.8 72.1025 285.256 79.996C283.712 87.8894 274.044 116.378 269.205 129.854C264.366 143.329 265.92 161.613 265.92 161.613C261.949 163.047 258.181 164.985 254.709 167.381C250.077 170.848 242.927 175.636 242.927 175.636L241 174.656C241 174.656 251.828 163.873 255.113 157.713C258.398 151.553 259.361 151.171 257.62 147.519C255.88 143.866 241.777 126.16 235.591 118.256C229.404 110.352 221.861 97.083 220.275 93.2343C218.862 89.9267 218.791 86.2022 220.078 82.8438C221.239 80.1508 232.067 74.7646 232.264 66.4894C232.461 58.2142 227.083 60.5151 222.016 62.2486C216.949 63.9821 203.458 77.0759 200.37 85.3512C197.282 93.6264 199.976 96.3195 205.395 101.324C210.815 106.328 217.415 116.533 220.897 126.16C224.379 135.787 228.824 145.022 235.974 147.529C235.974 147.529 224.576 152.915 217.032 158.301C209.488 163.687 205.82 166.195 205.82 166.195C205.82 166.195 195.572 169.084 191.707 174.088C189.639 176.658 187.828 179.423 186.298 182.343C186.298 182.343 151.315 188.317 140.487 197.562Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M232.969 215.815L216.462 223.44C216.462 223.44 217.26 235.874 212.835 242.292C208.411 248.71 206.794 250.711 206.794 250.711C206.794 250.711 206.39 260.338 203.572 266.354C200.753 272.369 196.318 274.371 196.318 274.371C196.324 276.627 195.862 278.86 194.962 280.93C194.062 283 192.742 284.863 191.085 286.402C185.448 291.623 171.397 300.043 162.486 305.656C161.564 306.244 160.683 306.863 159.833 307.503L161.906 309.195C169.088 303.873 176.715 299.171 184.702 295.142C198.038 288.404 201.282 283.596 205.188 275.702C208.733 267.843 211.705 259.739 214.079 251.454C214.276 250.103 218.141 246.646 218.721 238.361L219.301 230.106L234.14 216.878L232.969 215.815Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M154.994 250.877C168.465 253.147 183.241 251.145 185.894 250.753C186.744 248.534 187.282 246.048 185.894 245.098C183.48 243.489 184.288 239.083 184.288 239.083C184.288 239.083 182.278 243.489 166.164 243.489C150.051 243.489 128.301 229.858 128.301 229.858C128.301 229.858 126.695 234.667 122.26 236.276C117.825 237.886 105.743 244.696 105.743 244.696C105.743 244.696 105.339 255.922 97.2874 262.743C89.236 269.563 79.9515 285.443 79.9515 285.443L78.4905 290.22L82.884 292.284C82.884 292.284 83.0809 286.093 92.7488 276.693C102.417 267.293 108.396 251.279 109.173 250.897C109.95 250.516 126.954 239.351 126.954 239.351C126.954 239.351 140.104 248.369 154.994 250.877Z"
      fill="black"
    />
    <path
      d="M140.487 197.562C140.487 197.562 124.446 201.793 117.69 208.149C110.934 214.505 107.826 226.247 107.826 226.247C107.826 226.247 98.738 233.944 94.4792 236.256C91.0126 237.997 87.929 240.409 85.4081 243.35C82.8871 246.29 80.9794 249.701 79.7961 253.384C76.3144 263.785 72.0659 287.269 72.0659 287.269L82.884 292.284C82.884 292.284 83.0808 286.093 92.7487 276.693C102.417 267.293 108.396 251.279 109.173 250.897C109.95 250.515 126.954 239.351 126.954 239.351C126.954 239.351 140.104 248.39 154.984 250.897C169.864 253.405 186.298 250.701 186.298 250.701L181.656 264.951C181.656 264.951 171.024 269.563 168.32 275.145C165.615 280.727 152.859 301.9 152.859 301.9L161.947 309.216C169.13 303.893 176.757 299.192 184.744 295.163C198.08 288.425 201.323 283.616 205.23 275.723C208.775 267.864 211.746 259.76 214.12 251.475C214.317 250.123 218.182 246.667 218.762 238.381L219.343 230.127L239.632 212.039C250.768 207.127 260.771 199.987 269.019 191.062C282.355 176.43 284.479 169.311 285.836 156.217C287.194 143.123 292.603 91.3564 292.789 90.5825C292.976 89.8087 294.727 85.9703 297.048 85.5782C299.369 85.1861 312.125 96.3607 313.866 97.5164C315.607 98.672 319.047 99.2498 319.462 95.5869C319.876 91.9239 316.757 82.8851 306.903 73.0724C297.048 63.2598 289.888 61.7224 287.577 64.2194C285.267 66.7164 286.8 72.1025 285.256 79.996C283.712 87.8894 274.044 116.378 269.205 129.854C264.366 143.329 265.92 161.613 265.92 161.613C261.949 163.047 258.181 164.985 254.709 167.381C250.077 170.848 242.927 175.636 242.927 175.636L241 174.656C241 174.656 251.828 163.873 255.113 157.713C258.398 151.553 259.361 151.171 257.62 147.519C255.88 143.866 241.777 126.16 235.591 118.256C229.404 110.352 221.861 97.083 220.275 93.2343C218.862 89.9267 218.791 86.2022 220.078 82.8438C221.239 80.1508 232.067 74.7646 232.264 66.4894C232.461 58.2142 227.083 60.5151 222.016 62.2486C216.949 63.9821 203.458 77.0759 200.37 85.3512C197.282 93.6264 199.976 96.3195 205.395 101.324C210.815 106.328 217.415 116.533 220.897 126.16C224.379 135.787 228.824 145.022 235.974 147.529C235.974 147.529 224.576 152.915 217.032 158.301C209.488 163.687 205.82 166.195 205.82 166.195C205.82 166.195 195.572 169.084 191.707 174.088C189.639 176.658 187.828 179.423 186.298 182.343C186.298 182.343 151.315 188.317 140.487 197.562Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M198.515 175.615C196.08 175.615 193.064 175.842 190.225 176.131C188.764 178.087 187.465 180.157 186.339 182.322C186.339 182.322 151.315 188.317 140.487 197.562C140.487 197.562 124.446 201.793 117.69 208.149C110.934 214.505 107.826 226.247 107.826 226.247C107.826 226.247 103.007 230.323 98.7484 233.47C102.095 233.232 107.722 233.367 110.717 236.483C113.711 239.599 113.546 245.191 113.11 248.411C118.354 245.016 126.954 239.372 126.954 239.372C126.954 239.372 140.104 248.411 154.984 250.918C169.864 253.425 186.298 250.722 186.298 250.722L185.552 253.012C188.339 250.949 194.36 247.853 203.116 251.3C205.092 251.998 206.876 253.146 208.328 254.653C209.78 256.159 210.858 257.983 211.478 259.977C212.97 255.613 214.048 252.115 214.131 251.496C214.328 250.144 218.193 246.687 218.773 238.402L219.353 230.147L236.451 214.897C236.813 211.193 236.347 205.497 232.886 197.614C226.12 182.157 204.463 175.615 198.515 175.615Z"
      :fill="color"
    />
    <path
      opacity="0.2"
      d="M154.994 250.877C168.465 253.147 183.241 251.145 185.894 250.753C186.744 248.534 187.282 246.048 185.894 245.098C183.48 243.489 184.288 239.083 184.288 239.083C184.288 239.083 182.278 243.489 166.164 243.489C150.051 243.489 128.301 229.858 128.301 229.858C128.301 229.858 126.695 234.667 122.26 236.276C117.825 237.886 105.743 244.696 105.743 244.696C105.743 244.696 105.339 255.922 97.2874 262.743C89.236 269.563 79.9515 285.443 79.9515 285.443L78.4905 290.22L82.884 292.284C82.884 292.284 83.0809 286.093 92.7488 276.693C102.417 267.293 108.396 251.279 109.173 250.897C109.95 250.516 126.954 239.351 126.954 239.351C126.954 239.351 140.104 248.369 154.994 250.877Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M232.969 215.815L216.462 223.44C216.462 223.44 217.26 235.874 212.835 242.292C208.411 248.71 206.794 250.711 206.794 250.711C206.794 250.711 206.39 260.338 203.572 266.354C200.753 272.369 196.318 274.371 196.318 274.371C196.324 276.627 195.862 278.86 194.962 280.93C194.062 283 192.742 284.863 191.085 286.402C185.448 291.623 171.397 300.043 162.486 305.656C161.564 306.244 160.683 306.863 159.833 307.503L161.906 309.195C169.088 303.873 176.715 299.171 184.702 295.142C198.038 288.404 201.282 283.596 205.188 275.702C208.733 267.843 211.705 259.739 214.079 251.454C214.276 250.103 218.141 246.646 218.721 238.361L219.301 230.106L234.14 216.878L232.969 215.815Z"
      fill="black"
    />
    <path
      d="M198.515 175.615C196.08 175.615 193.064 175.842 190.225 176.131C188.764 178.087 187.465 180.157 186.339 182.322C186.339 182.322 151.315 188.317 140.487 197.562C140.487 197.562 124.446 201.793 117.69 208.149C110.934 214.505 107.826 226.247 107.826 226.247C107.826 226.247 103.007 230.323 98.7484 233.47C102.095 233.232 107.722 233.367 110.717 236.483C113.711 239.599 113.546 245.191 113.11 248.411C118.354 245.016 126.954 239.372 126.954 239.372C126.954 239.372 140.104 248.411 154.984 250.918C169.864 253.425 186.298 250.722 186.298 250.722L185.552 253.012C188.339 250.949 194.36 247.853 203.116 251.3C205.092 251.998 206.876 253.146 208.328 254.653C209.78 256.159 210.858 257.983 211.478 259.977C212.97 255.613 214.048 252.115 214.131 251.496C214.328 250.144 218.193 246.687 218.773 238.402L219.353 230.147L236.451 214.897C236.813 211.193 236.347 205.497 232.886 197.614C226.12 182.157 204.463 175.615 198.515 175.615Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M192.868 225.659C189.038 228.263 186.291 232.165 185.137 236.638C183.21 244.139 185.334 248.565 185.334 248.565"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M132.943 194.632C132.943 194.632 124.27 198.511 121.234 196.788C118.198 195.065 118.633 187.719 122.27 183.612C125.908 179.505 133.12 179.072 130.736 178.453C128.353 177.834 123.794 176.503 128.778 172.623C133.762 168.743 148.3 165.276 160.237 168.733C172.174 172.19 176.506 178.669 177.366 181.693C177.817 183.03 178.109 184.415 178.236 185.82C178.236 185.82 183.417 183.664 184.308 185.397C184.565 185.845 184.662 186.366 184.583 186.876C184.504 187.386 184.254 187.854 183.873 188.204C183.873 188.204 185.832 190.143 186.257 194.683C186.681 199.223 183.656 203.32 181.925 205.002C180.195 206.684 177.583 207.168 174.547 204.579C171.511 201.989 169.781 193.125 167.822 193.125C165.864 193.125 157.626 193.559 157.46 192.094L157.253 190.587L135.119 196.2L132.943 194.632Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M178.184 213.535C178.184 213.535 179.728 232.015 174.506 241.25C169.283 250.484 159.812 243.943 157.688 241.827C155.564 239.712 167.553 230.859 170.257 223.925C172.962 216.991 177.21 209.738 178.184 213.535Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M178.184 213.535C178.184 213.535 179.728 232.015 174.506 241.25C169.283 250.484 159.812 243.943 157.688 241.827C155.564 239.712 167.553 230.859 170.257 223.925C172.962 216.991 177.21 209.738 178.184 213.535Z"
      fill="black"
    />
    <path
      d="M178.184 213.535C178.184 213.535 179.728 232.015 174.506 241.25C169.283 250.484 159.812 243.943 157.688 241.827C155.564 239.712 167.553 230.859 170.257 223.925C172.962 216.991 177.21 209.738 178.184 213.535Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M132.943 194.632C133.514 204.875 135.559 214.983 139.016 224.648C144.653 239.981 154.196 245.171 158.32 245.387C162.444 245.604 170.247 237.824 173.718 230.478C176.046 225.367 178.006 220.098 179.583 214.711C179.583 214.711 184.568 212.988 185.873 208.448C187.179 203.908 186.909 199.812 183.48 199.378C180.05 198.945 178.495 203.918 178.495 203.918C175.614 201.831 173.485 198.875 172.423 195.488C170.682 189.875 174.154 185.552 172.423 186.635C170.693 187.719 167.242 191.175 165.481 190.525C163.719 189.875 166.517 184.912 166.517 184.912C166.517 184.912 138.415 192.248 132.943 194.632Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M169.822 206.075L179.366 202.402"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M147.264 207.158L128.177 203.702C128.177 203.702 128.394 209.748 131.43 213.205C134.467 216.661 140.756 217.095 143.14 216.228C145.523 215.361 145.088 208.665 147.699 209.315C150.31 209.965 149.865 212.771 150.953 215.361C152.041 217.951 153.118 217.734 157.885 218.385C162.652 219.035 167.211 218.601 168.952 216.228C170.693 213.855 171.553 206.508 169.822 206.075C168.092 205.642 162.227 206.508 155.937 206.725C149.647 206.942 147.264 207.158 147.264 207.158Z"
      fill="white"
    />
    <path
      d="M157.885 218.385C162.662 219.035 167.211 218.601 168.952 216.228C170.206 214.505 171.024 210.192 170.693 207.767L152.041 217.053C152.984 217.9 154.517 217.931 157.885 218.385Z"
      :fill="color"
    />
    <path
      d="M143.14 216.228C145.523 215.361 145.088 208.665 147.699 209.315C149.243 209.707 149.72 210.862 150.082 212.286L156.652 206.694H155.937C154.072 206.756 152.548 206.818 151.336 206.88L132.456 214.102C133.983 215.192 135.726 215.945 137.568 216.312C139.41 216.678 141.309 216.65 143.14 216.228Z"
      :fill="color"
    />
    <path
      d="M147.264 207.158L128.177 203.702C128.177 203.702 128.394 209.748 131.43 213.205C134.467 216.661 140.756 217.095 143.14 216.228C145.523 215.361 145.088 208.665 147.699 209.315C150.31 209.965 149.865 212.771 150.953 215.361C152.041 217.951 153.118 217.734 157.885 218.385C162.652 219.035 167.211 218.601 168.952 216.228C170.693 213.855 171.553 206.508 169.822 206.075C168.092 205.642 162.227 206.508 155.937 206.725C149.647 206.942 147.264 207.158 147.264 207.158Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M145.958 214.072C145.958 214.072 145.741 219.685 145.741 223.141C145.741 226.598 147.046 226.598 149.43 226.381C150.757 226.3 152.035 225.85 153.119 225.081"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M153.554 232.438C153.554 232.438 158.103 226.392 162.662 227.031C167.221 227.671 167.211 231.788 164.828 233.305C162.444 234.822 156.372 235.678 154.849 235.245C153.326 234.811 152.683 233.294 153.554 232.438Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M165.045 228.538C165.045 228.538 159.408 233.294 153.771 233.501"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M148.342 202.185C148.342 202.185 151.16 205.208 152.248 204.352C153.336 203.495 157.243 199.595 161.792 199.193C166.341 198.79 166.973 199.626 166.351 198.759C165.729 197.892 162.662 196.386 158.973 196.819C155.284 197.253 152.683 200.947 151.378 201.566C150.417 201.971 149.385 202.181 148.342 202.185Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M143.357 201.328C143.357 201.328 142.922 203.052 142.269 203.268C141.617 203.485 141.399 203.485 137.72 202.402C134.042 201.318 132.943 201.112 132.943 201.112C132.943 201.112 132.726 199.378 135.327 199.162C137.928 198.945 141.192 200.895 141.192 200.895C141.192 200.895 142.705 201.968 143.357 201.328Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M168.734 172.169C168.734 172.169 178.495 176.296 179.366 192.465L181.314 192.248C181.315 187.276 180.281 182.357 178.278 177.803C175.024 170.869 168.734 172.169 168.734 172.169Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M177.252 199.254C176.532 199.237 175.842 198.971 175.297 198.502C174.752 198.034 174.388 197.392 174.266 196.686C174.143 195.98 174.271 195.253 174.627 194.63C174.982 194.007 175.544 193.526 176.216 193.27L185.345 190.02C186.09 189.842 186.875 189.946 187.549 190.31C188.223 190.674 188.738 191.273 188.995 191.993C189.252 192.712 189.233 193.5 188.942 194.206C188.65 194.913 188.107 195.487 187.417 195.818L178.288 199.069C177.956 199.19 177.605 199.253 177.252 199.254Z"
      fill="white"
      stroke="#263238"
      stroke-miterlimit="10"
    />
    <path
      d="M178.184 195.787C178.682 197.119 178.288 198.501 177.293 198.883C176.299 199.265 175.086 198.481 174.578 197.139C174.071 195.798 174.475 194.425 175.47 194.044C176.464 193.662 177.677 194.456 178.184 195.787Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M177.096 212.978C177.096 213.525 176.878 214.05 176.489 214.437C176.101 214.824 175.574 215.041 175.024 215.041C174.474 215.041 173.947 214.824 173.559 214.437C173.17 214.05 172.952 213.525 172.952 212.978C172.952 211.832 175.024 207.272 175.024 207.272C175.024 207.272 177.096 211.801 177.096 212.978Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M287.629 64.1781C285.308 66.6751 286.852 72.0613 285.308 79.9547C283.764 87.8482 274.096 116.337 269.257 129.812C264.418 143.288 265.972 161.572 265.972 161.572C262.001 163.005 258.232 164.944 254.76 167.34C250.129 170.807 242.979 175.595 242.979 175.595L241 174.656C241 174.656 251.828 163.873 255.113 157.713C258.398 151.553 259.361 151.171 257.62 147.519C255.88 143.866 241.777 126.16 235.591 118.256C229.404 110.352 221.861 97.083 220.275 93.2343C218.862 89.9267 218.791 86.2022 220.078 82.8438C221.239 80.1508 232.067 74.7646 232.264 66.4894C232.461 58.2142 227.083 60.5151 222.016 62.2486C216.949 63.9821 203.458 77.0759 200.37 85.3512C197.282 93.6264 199.976 96.3195 205.395 101.324C210.815 106.328 217.415 116.533 220.897 126.16C224.379 135.787 228.824 145.022 235.974 147.529C235.974 147.529 224.576 152.915 217.032 158.301C209.488 163.687 205.82 166.195 205.82 166.195C205.82 166.195 195.572 169.084 191.707 174.088C190.022 176.233 188.489 178.491 187.117 180.847C191.531 179.237 202.225 176.771 214.711 184.086C230.202 193.156 233.487 208.211 233.487 217.487L239.642 211.997C250.779 207.086 260.782 199.945 269.029 191.02C282.365 176.389 284.489 169.269 285.847 156.176C287.204 143.082 292.613 91.3151 292.8 90.5412C292.986 89.7674 294.738 85.929 297.059 85.5369C299.38 85.1448 312.136 96.3195 313.876 97.4751C315.617 98.6307 319.057 99.2086 319.472 95.5456C319.886 91.8826 316.767 82.8438 306.913 73.0312C297.059 63.2185 289.898 61.6708 287.629 64.1781Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M220.7 167.722C220.7 167.722 241.196 170.425 252.014 186.976"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M319.472 95.5456C319.866 91.893 316.767 82.8439 306.913 73.0312C297.059 63.2185 289.899 61.6811 287.588 64.1781C285.277 66.6751 286.811 72.0613 285.267 79.9548C285.059 80.9866 284.697 82.4518 284.23 84.1646C286.501 83.8546 288.805 84.4152 290.676 85.733C291.85 86.4805 292.898 87.4066 293.784 88.4776C294.551 87.1878 295.701 85.7639 297.069 85.5369C299.38 85.1552 312.146 96.3195 313.887 97.4751C315.628 98.6308 319.089 99.2086 319.472 95.5456Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M205.437 101.324C206.615 102.434 207.722 103.616 208.753 104.863C211.489 104.882 214.179 104.162 216.536 102.779C218.894 101.396 220.831 99.4028 222.14 97.0108C221.301 95.4115 220.659 94.0804 220.317 93.2343C218.903 89.9267 218.833 86.2022 220.12 82.8438C221.28 80.1508 232.109 74.7646 232.306 66.4894C232.503 58.2142 227.125 60.5151 222.058 62.2486C216.991 63.9821 203.499 77.0759 200.411 85.3512C197.323 93.6264 200.017 96.3195 205.437 101.324Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M222.058 62.2486C217.032 63.9821 203.499 77.0759 200.411 85.3512C197.976 91.8414 199.137 94.9059 202.359 98.3315C203.829 97.9395 205.204 97.2551 206.4 96.3195C211.043 92.8526 212.97 86.6925 215.871 84.5773C217.519 83.3701 220.483 81.4818 223.488 79.4698C227.073 76.4465 232.171 72.1438 232.306 66.4894C232.492 58.2039 227.083 60.5151 222.058 62.2486Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M222.058 62.2487C217.032 63.9822 203.499 77.0761 200.411 85.3513C198.681 89.9636 198.764 92.8424 200.111 95.36C201.149 95.5452 202.215 95.5027 203.235 95.2354C204.255 94.9681 205.205 94.4824 206.017 93.8123C212.39 89.2 210.069 84.3814 215.675 81.6883C221.461 78.8632 226.743 75.1126 231.311 70.5859C231.932 69.2937 232.285 67.8898 232.347 66.4586C232.492 58.204 227.083 60.5153 222.058 62.2487Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M319.472 95.5456C319.866 91.893 316.767 82.8439 306.913 73.0312C297.059 63.2185 289.898 61.6811 287.588 64.1781C286.904 64.9997 286.482 66.0056 286.375 67.0672C288.199 66.4172 291.266 66.0354 295.318 67.8308C302.084 70.9263 314.446 86.3108 316.384 90.531C317.514 93.0073 317.192 96.0512 316.923 98.3212C318.166 98.3006 319.265 97.5164 319.472 95.5456Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M242.212 203.464L233.166 210.77C233.077 210.844 233.007 210.937 232.96 211.043C232.913 211.148 232.892 211.263 232.896 211.378L233.207 219.344C233.216 219.481 233.261 219.614 233.34 219.727C233.418 219.84 233.526 219.93 233.652 219.986C233.778 220.042 233.917 220.063 234.055 220.047C234.192 220.03 234.321 219.976 234.43 219.891L243.756 212.4C243.859 212.336 243.944 212.248 244.005 212.144C244.067 212.039 244.102 211.922 244.108 211.802L243.487 203.991C243.487 203.843 243.443 203.699 243.361 203.577C243.279 203.454 243.163 203.359 243.026 203.302C242.89 203.246 242.739 203.231 242.594 203.26C242.449 203.289 242.316 203.36 242.212 203.464Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.097 121.682C237.822 82.9953 237.822 44.7764 238.097 7.02539"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.098 206.611V121.682"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M181.656 183.127C181.862 124.313 181.862 65.499 181.656 7.0564"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M172.382 285.67C167.895 283.286 165.418 282.791 164.092 282.771C162.413 285.701 160.507 288.961 158.735 291.954C161.926 292.47 166.693 293.656 169.636 296.277C171.264 297.713 172.702 299.35 173.915 301.147C176.381 299.651 179.096 298.052 182.122 296.483C180.506 293.316 177.293 288.28 172.382 285.67Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M173.459 279.448L158.289 297.629L167.563 303.51L185.542 285.598L173.459 279.448Z"
      fill="#263238"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M174.299 282.616L162.88 296.05L167.366 298.661L180.485 285.412L174.299 282.616Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M73.6203 301.57C73.7239 296.824 71.5479 289.88 71.0194 288.373C69.807 284.648 67.1129 283.111 64.9783 285.04C63.2789 286.598 64.3047 290.096 64.7088 291.974C65.2746 295.342 66.078 298.666 67.1129 301.921C67.5792 303.221 68.1491 305.687 69.7552 306.048C72.5841 306.647 73.5478 304.542 73.6203 301.57Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M67.6827 305.553C67.7656 301.983 66.0973 296.772 65.7347 295.637C64.8124 292.841 62.7918 291.685 61.196 293.14C59.9111 294.306 60.6883 296.937 60.9888 298.351C61.4132 300.88 62.0157 303.376 62.7918 305.821C63.1441 306.791 63.569 308.638 64.7813 308.917C66.9159 309.35 67.6309 307.761 67.6827 305.553Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M85.3605 289.88C85.3605 289.88 89.754 295.266 93.4637 295.771C94.8429 295.895 96.1736 296.34 97.3488 297.069C98.524 297.799 99.5109 298.793 100.23 299.971C101.411 301.828 97.5256 308.05 97.3495 310.238C97.1733 312.425 95.6604 312.765 93.6398 311.589C91.6192 310.413 90.9353 307.214 91.5674 304.851C92.1995 302.489 92.6036 301.828 92.0752 301.653C90.0068 301.111 87.9752 300.439 85.9926 299.641C84.8528 298.97 85.3605 289.88 85.3605 289.88Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M80.4385 300.105C80.5421 295.359 78.3661 288.414 77.8376 286.908C76.6252 283.183 73.9207 281.646 71.7965 283.575C70.0971 285.133 71.1229 288.631 71.5271 290.509C72.0929 293.877 72.8962 297.2 73.9311 300.456C74.3974 301.756 74.9673 304.222 76.5734 304.583C79.4023 305.161 80.3867 303.056 80.4385 300.105Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M88.5417 302.004C88.6453 297.257 86.4693 290.303 85.9408 288.807C84.7284 285.082 82.0239 283.544 79.8997 285.474C78.2003 287.021 79.2261 290.53 79.6199 292.408C80.1892 295.776 80.996 299.099 82.0343 302.354C82.5006 303.644 83.0705 306.121 84.6766 306.482C87.5055 307.06 88.4691 304.955 88.5417 302.004Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M152.383 323.662C153.844 318.41 158.455 311.909 159.47 310.506C161.968 307.049 165.294 306.719 166.869 309.897C168.133 312.456 165.895 315.778 164.859 317.636C163.164 321 161.221 324.235 159.046 327.314C158.134 328.49 156.724 330.926 154.901 330.482C151.782 329.708 151.471 326.922 152.383 323.662Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M160.248 326.953C161.346 323.011 164.807 318.131 165.563 317.078C167.449 314.478 169.936 314.231 171.118 316.624C172.071 318.544 170.392 321.03 169.615 322.423C168.347 324.954 166.888 327.386 165.253 329.698C164.558 330.585 163.512 332.411 162.144 332.071C159.792 331.493 159.564 329.429 160.248 326.953Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M147.015 300.91C147.015 300.91 140.653 304.604 136.601 303.283C132.55 301.962 130.011 303.066 128.167 304.49C126.322 305.914 128.301 314.695 127.752 317.182C127.203 319.668 128.685 320.793 131.182 320.515C133.679 320.236 135.451 317.089 135.534 314.169C135.617 311.249 135.482 310.341 136.062 310.413C136.643 310.485 141.617 311.445 143.078 311.259C144.539 311.073 147.015 300.91 147.015 300.91Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M148.777 314.582C150.238 309.33 154.839 302.829 155.854 301.426C158.362 297.969 161.678 297.639 163.253 300.827C164.517 303.376 162.289 306.698 161.242 308.556C159.555 311.922 157.615 315.158 155.44 318.234C154.517 319.421 153.119 321.846 151.295 321.402C148.155 320.628 147.844 317.852 148.777 314.582Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M139.679 312.59C141.14 307.338 145.751 300.838 146.766 299.434C149.264 295.978 152.59 295.648 154.165 298.826C155.429 301.385 153.191 304.707 152.155 306.564C150.46 309.929 148.517 313.164 146.342 316.243C145.43 317.419 144.02 319.854 142.197 319.411C139.078 318.637 138.767 315.851 139.679 312.59Z"
      fill="white"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.5601 281.088L56.015 331.328L154.984 365.719L149.316 317.728L37.5601 281.088Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M260.604 252.476H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 252.476H249.134"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M286.562 258.192H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M271.091 258.192H282.075"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 258.192H263.599"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M264.107 263.898H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 263.898H258.118"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M280.075 269.615H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M250.129 269.615H275.081"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 269.615H244.637"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M260.604 274.609H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 274.609H249.134"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M286.562 280.325H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M271.091 280.325H282.075"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 280.325H263.599"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M264.107 286.031H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 286.031H258.118"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M286.562 296.762H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M271.091 296.762H282.075"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 296.762H263.599"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M264.107 302.468H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 302.468H258.118"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M280.075 308.184H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M250.129 308.184H275.081"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 308.184H244.637"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M260.604 313.178H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 313.178H249.134"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M286.562 318.884H292.054"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M271.091 318.884H282.075"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M238.15 318.884H263.599"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M298.613 329.306L302.654 311.166L306.706 322.589L312.104 273.556L319.524 311.166L328.29 246.007L337.74 321.237L341.782 313.849L343.802 328.635"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M242.388 241.446L265.589 218.354L282.655 233.604L297.1 220.531L318.539 236.658L341.74 212.245"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M268.646 218.354C268.656 217.737 268.481 217.132 268.143 216.615C267.806 216.098 267.321 215.693 266.751 215.453C266.181 215.212 265.551 215.146 264.943 215.264C264.336 215.382 263.777 215.678 263.339 216.114C262.901 216.55 262.604 217.106 262.486 217.711C262.368 218.316 262.434 218.943 262.675 219.511C262.917 220.078 263.323 220.561 263.842 220.897C264.362 221.234 264.97 221.408 265.589 221.398C266.395 221.384 267.165 221.059 267.735 220.491C268.306 219.923 268.632 219.157 268.646 218.354Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M300.157 220.531C300.157 219.916 299.973 219.316 299.629 218.806C299.285 218.296 298.797 217.899 298.226 217.666C297.654 217.434 297.027 217.375 296.422 217.499C295.818 217.623 295.264 217.923 294.832 218.361C294.399 218.799 294.107 219.355 293.993 219.959C293.879 220.563 293.948 221.187 294.191 221.752C294.435 222.316 294.841 222.796 295.359 223.13C295.877 223.464 296.483 223.637 297.1 223.626C297.915 223.613 298.693 223.281 299.265 222.702C299.837 222.123 300.157 221.343 300.157 220.531Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M318.539 239.712C320.233 239.712 321.606 238.345 321.606 236.658C321.606 234.971 320.233 233.604 318.539 233.604C316.845 233.604 315.472 234.971 315.472 236.658C315.472 238.345 316.845 239.712 318.539 239.712Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M344.372 212.245C344.372 211.633 344.19 211.034 343.848 210.525C343.507 210.016 343.021 209.62 342.453 209.385C341.885 209.151 341.26 209.09 340.657 209.209C340.054 209.329 339.5 209.623 339.065 210.056C338.631 210.489 338.334 211.041 338.215 211.641C338.095 212.242 338.156 212.864 338.391 213.43C338.627 213.995 339.025 214.479 339.536 214.819C340.048 215.159 340.649 215.341 341.263 215.341C342.088 215.341 342.879 215.015 343.462 214.434C344.045 213.853 344.372 213.066 344.372 212.245Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M242.388 244.5C244.082 244.5 245.455 243.133 245.455 241.446C245.455 239.759 244.082 238.392 242.388 238.392C240.694 238.392 239.321 239.759 239.321 241.446C239.321 243.133 240.694 244.5 242.388 244.5Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M282.655 235.781C284.349 235.781 285.722 234.414 285.722 232.727C285.722 231.04 284.349 229.673 282.655 229.673C280.961 229.673 279.588 231.04 279.588 232.727C279.588 234.414 280.961 235.781 282.655 235.781Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M76.1898 141.72L85.2049 136.54"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.2338 136.54V166.989L58.7194 182.219L85.2049 166.989V136.54L58.7194 121.31L32.2338 136.54Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.2384 141.72V161.81L58.7193 171.86L76.1898 161.81V141.72L58.7193 131.67L41.2384 141.72Z"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M58.7194 121.31V98.6929"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M58.7194 102.015C61.1859 102.015 63.1854 100.024 63.1854 97.568C63.1854 95.1119 61.1859 93.1208 58.7194 93.1208C56.2528 93.1208 54.2533 95.1119 54.2533 97.568C54.2533 100.024 56.2528 102.015 58.7194 102.015Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M58.7194 181.579V204.197"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.2429 205.322C54.2409 206.204 54.5017 207.067 54.9923 207.801C55.4829 208.535 56.1813 209.108 56.9991 209.447C57.8169 209.786 58.7173 209.876 59.5863 209.705C60.4553 209.534 61.2539 209.111 61.881 208.488C62.5081 207.865 62.9355 207.07 63.109 206.205C63.2826 205.34 63.1946 204.444 62.856 203.629C62.5175 202.813 61.9438 202.117 61.2074 201.626C60.4711 201.136 59.6052 200.875 58.7194 200.875C57.5339 200.875 56.3969 201.343 55.5577 202.176C54.7185 203.01 54.2457 204.141 54.2429 205.322Z"
      :fill="color"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.2385 141.72L32.2338 136.54"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42.0052 161.964L59.4758 151.914L76.1899 161.81"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M59.4758 151.914V131.67"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.141 53.2925H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.1947 53.2925H108.157"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 53.2925H77.7028"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M93.6812 58.2866H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 58.2866H82.1999"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M119.638 64.0029H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M104.157 64.0029H115.141"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 64.0029H96.6758"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M97.1732 69.7087H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 69.7087H91.1839"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.141 75.425H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.1947 75.425H108.157"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 75.425H77.7028"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M93.6812 80.4192H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 80.4192H82.1999"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M119.638 86.1252H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M104.157 86.1252H115.141"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 86.1252H96.6758"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M97.1732 91.8416H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 91.8416H91.1839"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.141 97.5474H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.1947 97.5474H108.157"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 97.5474H77.7028"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M93.6812 102.552H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 102.552H82.1999"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M125.12 108.258H119.638"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M104.157 108.258H115.141"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 108.258H96.6758"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M97.1732 113.974H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 113.974H91.1839"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M113.141 119.68H125.12"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.1947 119.68H108.157"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M71.2161 119.68H77.7028"
      stroke="#263238"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  import { getColor } from '../../mixins/getColor'

  export default {
    mixins: [getColor()]
  }
</script>
